import axiosInstance from "../axiosInstance";

export const catalogPlanService = {
  /** List plans; optionally filter by client and/or year */
  fetch: async ({ client_id, year, limit = 50, skip = 0 } = {}) => {
    try {
      let api = `/catalog-plan?$limit=${limit}&$skip=${skip}&$sort[createdAt]=-1`;
      if (client_id) api += `&client_id=${client_id}`;
      if (year) api += `&year=${year}`;
      const response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await axiosInstance.get(`/catalog-plan/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await axiosInstance.post("/catalog-plan", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await axiosInstance.patch(`/catalog-plan/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/catalog-plan/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
